import { render, staticRenderFns } from "./AppFooter.html?vue&type=template&id=654d0eaa&scoped=true&external"
import script from "./AppFooter.ts?vue&type=script&lang=ts&external"
export * from "./AppFooter.ts?vue&type=script&lang=ts&external"
import style0 from "./AppFooter.scss?vue&type=style&index=0&id=654d0eaa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d0eaa",
  null
  
)

export default component.exports